module.exports = __webpack_public_path__ + "img/2-3.540f31e2.svg";